import React from 'react';
import PropTypes from 'prop-types';
import {
  FDEmptyState, FDList,
} from '@facet-wealth/design';
import { CashFlowItem } from './CashFlowItem';

export const CashFlowItems = ({
  lineItemsCollection,
  onEditItemClick,
  emptyTitle,
  emptyDescription,
}) => {
  const lineItemResources = lineItemsCollection.resources().list();
  return (
    <>
      {lineItemResources.length === 0 ? (
        <FDEmptyState
          icon={'search'}
          title={emptyTitle}
          description={emptyDescription}
        />
      ) : (
        <FDList>
          {lineItemResources.map((lineItemResource, idx) => {
            return (
              <CashFlowItem
                key={lineItemResource.id()}
                index={idx}
                lineItemResource={lineItemResource}
                onEditClick={onEditItemClick}
              />
            );
          })}
        </FDList>
      )}
    </>
  );
};

CashFlowItems.defaultProps = {
  emptyTitle: 'Nothing to see here',
  emptyDescription: 'Link or add some data to populate this section',
};

CashFlowItems.propTypes = {
  lineItemsCollection: PropTypes.object.isRequired,
  onEditItemClick: PropTypes.func.isRequired,
  emptyTitle: PropTypes.string,
  emptyDescription: PropTypes.string,
};
